import React from "react";
import {useTranslation} from "react-i18next";
import {inject, observer} from "mobx-react";
// local
import OverviewManualCardView from "../../OverviewCard/OverviewManualCardView";
import PresentationCardWrapper from "../../PresentationCardWrapper";
import {dateFormat} from "helpers/datetime";
import InsuranceEdit from "./InsuranceEdit";
import EmptyData from "components/EmptyData";
import {IconFirstAid} from "components/icons";
import {LockValue} from "components/LockValue";

const Insurance = inject("store")(
  observer(({store: {organization}, edit, setEdit}) => {
    const {t} = useTranslation();
    const closeEdit = () => setEdit({...edit, insurance: false});

    if (edit.insurance) return <InsuranceEdit closeEdit={closeEdit} />;

    const mapData = () =>
      !!organization.organizationDetail?.Insurances?.length &&
      organization.organizationDetail?.Insurances.map((item) => (
        <OverviewManualCardView
          key={item.id}
          firstParameter={item.insuranceName}
          secondParameter={item.insuranceCompany}
          validDate={dateFormat(item.valid)}
          meets={item.meets}
          files={item.Files}
        />
      ));

    return (
      <PresentationCardWrapper
        icon={<IconFirstAid />}
        edit={edit}
        setEdit={setEdit}
        editName="insurance"
        editPermissions={["EDIT_OUR_PROFILE_MAIN_INFO"]}
        title={t("INSURANCE")}
        addClass="__insurance-area"
        isActive={organization.organizationDetail?.isActive}
      >
        <LockValue
          canPermissions={["READ_OTHER_INSURANCE"]}
          noHideOurInfo
          fullSubcribeButton
          needMiniSibscribeButton
        >
          {mapData() || <EmptyData />}
        </LockValue>
      </PresentationCardWrapper>
    );
  })
);

export default Insurance;
